import { Box, Typography } from "@mui/material";
import DotLegalLogo from "../main/NavMenu/dotLegalLogo.svg?react";
import { useTranslation } from "@localization/useTranslation";
import { useUserContext } from "../auth/userContextProvider/UserContextProvider";
import { usePdfReportFrontPageStyles } from "./pdfReportFrontPage.styles";

// The cover height must match the printed page so the background fills it; A4 is 210mm tall in landscape
// and 297mm in portrait.
const pageHeightByOrientation = { landscape: "210mm", portrait: "297mm" } as const;

interface PdfReportFrontPageProps {
    title: string;
    orientation?: "landscape" | "portrait";
}

function PdfReportFrontPage({ title, orientation = "landscape" }: PdfReportFrontPageProps) {
    const styles = usePdfReportFrontPageStyles();
    const { translateString, translateDate } = useTranslation();
    const { customerName } = useUserContext();

    return (
        <Box sx={[styles.root, { height: pageHeightByOrientation[orientation] }]} className="page-break-after">
            <Box sx={{ display: "flex", color: "primary.dark", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
                <Box>
                    <Typography mb={4} sx={[styles.bold, { fontSize: 60, textTransform: "capitalize" }]}>
                        {title}
                    </Typography>
                    <Typography sx={[styles.bold, { fontSize: 35 }]}>{customerName}</Typography>
                </Box>

                <Box mt={9}>
                    <Typography sx={{ fontSize: 25, mt: 2 }}>
                        <Box component={"span"} sx={styles.bold}>
                            {translateString("date")}:&nbsp;
                        </Box>
                        {translateDate(new Date())}
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ position: "absolute", bottom: 0, right: 0 }}>
                <Box mr={5} mb={3} sx={{ "& svg": { height: 55, width: 165 } }}>
                    <DotLegalLogo />
                </Box>
            </Box>
        </Box>
    );
}

export default PdfReportFrontPage;
